import MuiIconCheckBox from '@mui/icons-material/CheckBox'
import MuiIconCheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank'
import { Autocomplete, Checkbox as MuiCheckbox, TextField } from '@mui/material'
import type { FC } from 'react'
import { ClinicalFocusArea } from './types'

interface ClinicalFocusAreaType {
  id: number
  clinicalFocusArea: string
}

interface ClinicalFocusAreaAutocompleteProps {
  onChangeClinicalFocusArea: (value: ClinicalFocusAreaType[]) => void
  clinicalFocusAreas: ClinicalFocusArea[]
  selectedClinicalFocusAreas: ClinicalFocusArea[]
  disabled?: boolean
  textFieldVariant?: 'outlined' | 'standard'
}

const ClinicalFocusAreaAutocomplete: FC<ClinicalFocusAreaAutocompleteProps> = props => {
  const selectedClinicalFocusArea = props?.selectedClinicalFocusAreas.map(option => {
    return {
      id: option.id,
      clinicalFocusArea: option.label,
    }
  })
  return (
    <Autocomplete
      disabled={props?.disabled}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      multiple
      disableCloseOnSelect
      filterSelectedOptions
      size="small"
      options={props?.clinicalFocusAreas?.map(
        option =>
          ({
            key: option.id,
            id: option.id,
            clinicalFocusArea: option.label,
          }) as ClinicalFocusAreaType,
      )}
      getOptionLabel={option => option.clinicalFocusArea}
      isOptionEqualToValue={(option, value) => option.id == value.id}
      renderInput={params => (
        <TextField
          variant={props?.textFieldVariant ?? 'standard'}
          {...params}
          label={'Focus Areas (Optional)'}
        />
      )}
      renderOption={({ key, ...props }, option, { selected }) => (
        <li key={key} {...props}>
          <MuiCheckbox
            icon={<MuiIconCheckBoxOutlineBlank fontSize="small" />}
            checkedIcon={<MuiIconCheckBox fontSize="small" />}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.clinicalFocusArea}
        </li>
      )}
      value={selectedClinicalFocusArea}
      onChange={(event, value) => {
        props?.onChangeClinicalFocusArea(value)
      }}
    />
  )
}

export default ClinicalFocusAreaAutocomplete
